module.exports = __webpack_public_path__ + "img/sort.5698900a.svg";